export default "__VITE_ASSET__1JBv1rsf__"